export default __webpack_public_path__ + "static/media/Mailbox.ea2c0159.mp4";